import React, { useState } from 'react';
import { CONTENT_TOP } from 'dashboard/layouts/admin/chromeGeometry';
import { Box, Divider, Stack } from '@mui/material';
import { useOutletContext } from 'react-router';
import {
  EmptyState,
  PageHeader,
  PagePaper,
} from 'dashboard/components/common';
import PrimaryDomainCard from './PrimaryDomainCard';
import RoutingRecordsCard from './RoutingRecordsCard';
import SubdomainRulesCard from './SubdomainRulesCard';

/**
 * Top-level "Domains / DNS" page under Brand Manager.
 *
 * Two stacked sections:
 *   1. Primary domain      — one per brand, verified via TXT record
 *   2. Subdomain routing   — maps `<sub>.<primary>` to a page or the
 *                            full storefront. Unmapped subdomains fall
 *                            back to a "Coming soon" page so the
 *                            domain serves something the moment DNS
 *                            verifies.
 */
export default function Domains() {
  const [selectedBrand] = useOutletContext();
  // Lifted so the subdomain card can show / hide based on whether the
  // primary is verified.
  const [primary, setPrimary] = useState(null);

  return (
    <Box sx={{ pt: CONTENT_TOP }}>
      <PagePaper>
        <PageHeader
          title='Domains'
          subtitle='Point your own domain at TechProOne. Verify ownership once, then map each subdomain to whatever you want it to serve — full storefront, a single page from the page builder, or a "Coming soon" placeholder.'
        />

        {!selectedBrand && (
          <EmptyState>Select a brand to manage its domains.</EmptyState>
        )}

        {selectedBrand && (
          <Stack spacing='24px' divider={<Divider />}>
            <PrimaryDomainCard
              brandId={selectedBrand}
              onPrimaryChanged={setPrimary}
            />
            <RoutingRecordsCard
              domain={primary?.domain}
              verified={primary?.status === 'verified'}
            />
            <SubdomainRulesCard
              brandId={selectedBrand}
              primary={primary}
            />
          </Stack>
        )}
      </PagePaper>
    </Box>
  );
}
